import MenuNames from "../../../constants/Menu/MenuNames.json";
import QRGenerator from "../../../views/QRGenerator";

const qrGeneratorRoutes = [
  {
    menuName: MenuNames.QR_GENERATOR,
    path: "/qr-generator",
    component: QRGenerator,
    exact: true,
  },
];

export default qrGeneratorRoutes;
